import { Directive, ElementRef, HostBinding,HostListener, Input, NgModule} from '@angular/core';
import Viewer from 'viewerjs';
import {ImagePreviewService} from './image-preview.service'

@Directive({
    selector: '[image-viewer]'
})
export class ImageViewerDirective {
  constructor(private el: ElementRef,
    private imagePreviewService: ImagePreviewService) {
  }
  @Input('image-viewer') imageList: [] = [];
  @HostBinding('viewer') _viewer:Viewer;
  @HostListener('load') onLoad(){
    if (this.imageList.length > 0) {
      this.imagePreviewService.preview(this.imageList)
      return
    }
    
    const viewer = new Viewer(this.el.nativeElement, {
      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: 4,
        rotateLeft: 4,
        rotateRight: 4,
        flipHorizontal: 4,
        flipVertical: 4
      },
      view() {
        viewer.zoomTo(2);
      }

    });

  };

}

@NgModule({
  imports: [],
  exports: [ImageViewerDirective],
  declarations: [ImageViewerDirective]
})
export class ImageViewerModule { }
